import {
  Box,
  Popper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { StyledBoxStatusIconComponent } from "./StatusIconComponent.style";
import { AppIconsInfo } from "../../AppIcons";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import {
    BoxStyled,
  TooltipContainer,
  TooltipStyled,
} from "./OfferOrderConditionsComponent.style";

type TOfferOrderConditionsComponent = {
  item: any;
};

const OfferOrderConditionsComponent = (
  props: TOfferOrderConditionsComponent
) => {
  const { t } = useTranslation();

  const renderTable = (conditions: any) => (
    <>
      {Object.entries(conditions).map(([key, value]) => (
        <BoxStyled key={"salesConditions_" + key}>
          <Typography variant="body2" fontWeight="bold">
            {t(`common.salesConditions.${String(key)}`)}
          </Typography>

          <Typography variant="body2">{String(value) || "N/A"}</Typography>
        </BoxStyled>
      ))}
    </>
  );

  var conditions = {
    currency: props.item.currency,
    carrier: props.item.carrier,
    deliveryTerms: props.item.deliveryTerms,
    paymentTerms: props.item.paymentTerms,
    paymentMethod: props.item.paymentMethod,
  };
  return (
    <TooltipStyled
      disableInteractive
      slotProps={{
        tooltip: {
          sx: {
            maxWidth: 400,
          },
        },
      }}
      title={
        <TooltipContainer>
          <Typography variant="subtitle1" gutterBottom>
            {t("common.salesCondition")}
          </Typography>
          {renderTable(conditions)}
        </TooltipContainer>
      }
      placement="top"
      arrow
    >
      <AppIconsInfo />
    </TooltipStyled>
  );
};

export default OfferOrderConditionsComponent;
